export const formatNumber = (num) => {
  if (num === null || num === undefined) return '';
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const parseNumber = (str) => {
  if (str === null || str === undefined || str === '') return 0;
  const parsed = parseFloat(String(str).replace(/\./g, ''));
  return isNaN(parsed) ? 0 : parsed;
};